import { ParticipantDateCreate } from './ParticipantDateCreate'
// import { ParticipantDateList } from './ParticipantDateList'

export const participant_date = {
  create: ParticipantDateCreate,
  // list: ParticipantDateList
}
